import React, { useState, useEffect } from "react";
import { Check, Clock, Package, Truck, ChevronDown, ChevronUp, Download } from 'lucide-react';
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./index.css";

import withAuth from "../../hoc/withAuth";

function OrderDetails() {
  const [isPaymentExpanded, setIsPaymentExpanded] = useState(true);
  const [isShippingExpanded, setIsShippingExpanded] = useState(true);
  const [isTimelineExpanded, setIsTimelineExpanded] = useState(true);
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const { orderId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        setLoading(true);
        const authToken = sessionStorage.getItem("authToken");
        const response = await axios.get(`https://derbyb.ritaz.in/api/orders/${orderId}`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        setOrder(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching order details:", err);
        setError("Failed to fetch order details. Please try again later.");
        setLoading(false);
      }
    };

    if (orderId) {
      fetchOrderDetails();
    }
  }, [orderId]);

  const handleBackToOrders = () => {
    navigate('/user-profile');
  };

  const generateInvoicePDF = () => {
  if (!order) return;

  const printWindow = window.open('', '_blank');
  const subtotal = order.totalAmount;
  const taxRate = 0.18;
  const taxAmount = subtotal * taxRate / (1 + taxRate);
  const beforeTax = subtotal - taxAmount;

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${day}/${month}/${year}, ${hours}:${minutes} ${ampm}`;
  };

    const invoiceHTML = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Invoice - Order #${order.orderId}</title>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          .company-logo {
            max-width: 120px;
            height: auto;
            margin-bottom: 10px;
          }
          body {
            font-family: 'Arial', sans-serif;
            font-size: 12px;
            line-height: 1.4;
            color: #333;
            background: white;
          }
          .invoice-container {
            max-width: 800px;
            margin: 20px auto;
            padding: 20px;
            background: white;
          }
          .invoice-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 30px;
            padding-bottom: 20px;
            border-bottom: 2px solid #e0e0e0;
          }
          .company-info h1 {
            color: #2c3e50;
            font-size: 24px;
            margin-bottom: 5px;
          }
          .company-info p {
            color: #666;
            font-size: 11px;
          }
          .invoice-title {
            text-align: right;
          }
          .invoice-title h2 {
            color: #e74c3c;
            font-size: 28px;
            margin-bottom: 5px;
          }
          .invoice-title p {
            color: #666;
            font-size: 11px;
          }
          .invoice-details {
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;
          }
          .bill-to, .invoice-info {
            flex: 1;
          }
          .bill-to {
            margin-right: 40px;
          }
          .section-title {
            color: #2c3e50;
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 10px;
            text-transform: uppercase;
          }
          .detail-item {
            margin-bottom: 5px;
            display: flex;
          }
          .detail-label {
            font-weight: bold;
            min-width: 80px;
            color: #555;
          }
          .detail-value {
            color: #333;
          }
          .items-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 30px;
          }
          .items-table th {
            background-color: #34495e;
            color: white;
            padding: 12px 8px;
            text-align: left;
            font-weight: bold;
            font-size: 11px;
            text-transform: uppercase;
          }
          .items-table td {
            padding: 12px 8px;
            border-bottom: 1px solid #e0e0e0;
            font-size: 11px;
          }
          .items-table tr:nth-child(even) {
            background-color: #f8f9fa;
          }
          .text-right {
            text-align: right;
          }
          .text-center {
            text-align: center;
          }
          .totals-section {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 30px;
          }
          .totals-table {
            width: 300px;
            border-collapse: collapse;
          }
          .totals-table td {
            padding: 8px 12px;
            border-bottom: 1px solid #e0e0e0;
          }
          .totals-table .total-label {
            font-weight: bold;
            text-align: right;
            color: #555;
          }
          .totals-table .total-value {
            text-align: right;
            font-weight: bold;
          }
          .final-total {
            background-color: #2c3e50;
            color: white;
            font-size: 14px;
          }
          .payment-terms {
            background-color: #f8f9fa;
            padding: 15px;
            border-left: 4px solid #3498db;
            margin-bottom: 20px;
          }
          .payment-terms h4 {
            color: #2c3e50;
            margin-bottom: 8px;
          }
          .footer {
            text-align: center;
            padding-top: 20px;
            border-top: 1px solid #e0e0e0;
            color: #666;
            font-size: 10px;
          }
          .status-badge {
            display: inline-block;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 10px;
            font-weight: bold;
            text-transform: uppercase;
          }
          .status-processing {
            background-color: #fff3cd;
            color: #856404;
          }
          .status-shipped {
            background-color: #d4edda;
            color: #155724;
          }
          .status-delivered {
            background-color: #d1ecf1;
            color: #0c5460;
          }
          .status-pending {
            background-color: #f8d7da;
            color: #721c24;
          }
          @media print {
            body {
              margin: 0;
              font-size: 11px;
            }
            .invoice-container {
              margin: 0;
              padding: 15px;
              max-width: 100%;
            }
            .invoice-header h1 {
              font-size: 20px;
            }
            .invoice-title h2 {
              font-size: 24px;
            }
            .company-logo {
              max-width: 100px;
            }
          }
        </style>
      </head>
      <body>
        <div class="invoice-container">
          <div class="invoice-header">
            <div class="company-info">
                <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1744269497/Naranja_Standy_Pouch_cpjz9i.png" 
                   class="company-logo" 
                   alt="DerbyB Logo" />
              <p>Your Sweet Destination</p>
              <p>Address Line 1</p>
              <p>City, State, PIN Code</p>
              <p>Phone: +91 XXXXXXXXXX</p>
              <p>Email: info@derbyb.com</p>
            </div>
            <div class="invoice-title">
              <h2>INVOICE</h2>
              <p>Order #${order.orderId}</p>
              <p>Date: ${formatDateTime(order.createdAt)}</p>
            </div>
          </div>
          
          <div class="invoice-details">
            <div class="bill-to">
              <div class="section-title">Bill To:</div>
              <div class="detail-item">
                <span class="detail-value">${order.user.fullName}</span>
              </div>
              <div class="detail-item">
                <span class="detail-value">${order.shippingAddress}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Phone:</span>
                <span class="detail-value">${order.user.phone}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Email:</span>
                <span class="detail-value">${order.user.email}</span>
              </div>
            </div>
            
            <div class="invoice-info">
              <div class="section-title">Order Information:</div>
              <div class="detail-item">
                <span class="detail-label">Status:</span>
                <span class="status-badge status-${order.orderStatus.toLowerCase()}">${order.orderStatus}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Payment:</span>
                <span class="detail-value">${order.paymentMethod}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Payment Status:</span>
                <span class="detail-value">${order.paymentStatus}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Order Date:</span>
                <span class="detail-value">${formatDateTime(order.createdAt)}</span>
              </div>
            </div>
          </div>
          
          <table class="items-table">
            <thead>
              <tr>
                <th style="width: 50%;">Item Description</th>
                <th style="width: 15%;" class="text-center">Qty</th>
                <th style="width: 15%;" class="text-right">Unit Price</th>
                <th style="width: 20%;" class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              ${order.items.map(item => `
                <tr>
                  <td>
                    <strong>${item.name}</strong>
                    ${item.productId && item.productId.packageWeight ? `<br><small>Weight: ${item.productId.packageWeight}</small>` : ''}
                    ${item.productId && item.productId.packageSize && item.productId.packageSize !== "0" ? `<br><small>Size: ${item.productId.packageSize}</small>` : ''}
                  </td>
                  <td class="text-center">${item.quantity}</td>
                  <td class="text-right">₹${item.price.toFixed(2)}</td>
                  <td class="text-right">₹${(item.price * item.quantity).toFixed(2)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          
          <div class="totals-section">
            <table class="totals-table">
              <tr>
                <td class="total-label">Subtotal:</td>
                <td class="total-value">₹${beforeTax.toFixed(2)}</td>
              </tr>
              <tr>
                <td class="total-label">Tax (GST 18%):</td>
                <td class="total-value">₹${taxAmount.toFixed(2)}</td>
              </tr>
              <tr class="final-total">
                <td class="total-label">Total Amount:</td>
                <td class="total-value">₹${order.totalAmount.toFixed(2)}</td>
              </tr>
            </table>
          </div>
          
          <div class="payment-terms">
            <h4>Payment Terms & Notes:</h4>
            <p>• Payment Method: ${order.paymentMethod}</p>
            <p>• Payment Status: ${order.paymentStatus}</p>
            <p>• All prices are inclusive of applicable taxes</p>
            <p>• For any queries, please contact our customer support</p>
          </div>
          
          <div class="footer">
            <p>Thank you for choosing DerbyB! We appreciate your business.</p>
            <p>This is a computer-generated invoice and does not require a signature.</p>
          </div>
        </div>
      </body>
      </html>
    `;
    
    printWindow.document.write(invoiceHTML);
    printWindow.document.close();
    
    printWindow.onload = function() {
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 250);
    };
  };

  const handleDownload = () => {
    generateInvoicePDF();
  };

  const formatDate = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const formatShortDate = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'numeric', 
      day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  if (loading) {
    return (
      <div className="order_details_loading">
        <div className="spinner"></div>
        <p>Loading order details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="order_details_error">
        <h3>Error</h3>
        <p>{error}</p>
        <button onClick={handleBackToOrders} className="order_details_action_button">
          Back to Orders
        </button>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="order_details_error">
        <h3>Order Not Found</h3>
        <p>The order you're looking for doesn't exist or you don't have permission to view it.</p>
        <button onClick={handleBackToOrders} className="order_details_action_button">
          Back to Orders
        </button>
      </div>
    );
  }

  return (
    <div className="order_details_container">
      <div className="order_details_main_wrapper">
        <div className="order_details_welcome_section">
          <div className="order_details_welcome_content">
            <h3 className="order_details_welcome_title">
              Hello, {order.user.fullName}! 🔍 Ready to unwrap more sweetness?
            </h3>
            <p className="order_details_welcome_subtitle">
              Manage your profile, track orders, and check your sweet rewards!
            </p>
          </div>
          <div className="order_details_download_icon" onClick={handleDownload}>
            <Download size={30} />
          </div>
        </div>

        <div className="order_details_navigation">
          <div className="order_details_back_button">
            <span onClick={handleBackToOrders}>Back to Orders</span>
          </div>
        </div>

        <div className="order_details_content">
          <div className="order_details_items">
            <div className="order_details_card">
              <div className="order_details_card_header">
                <div className="order_details_header_content">
                  <h4 className="order_details_card_title">Order #{order.orderId}</h4>
                  <span className={`order_details_status order_details_status_${order.orderStatus.toLowerCase()}`}>
                    {order.orderStatus}
                  </span>
                </div>
                <p className="order_details_date">Placed on {formatShortDate(order.createdAt)}</p>
              </div>

              <div className="order_details_items_list">
                {order.items.map((item, index) => (
                  <div className="order_details_item" key={index}>
                    <div className="order_details_item_row">
                      <div className="order_details_item_image">
                        <img
                          src={item.mainImage || "/placeholder.svg"}
                          alt={item.name}
                          className="order_details_product_image"
                        />
                      </div>
                      <div className="order_details_item_details">
                        <h3 className="order_details_item_title">{item.name}</h3>
                        <div className="order_details_item_info">
                          {item.productId && item.productId.mrp && (
                            <div className="order_details_info_group">
                              <p className="order_details_info_label">MRP</p>
                              <p className="order_details_info_value">₹{item.productId.mrp.toFixed(2)}</p>
                            </div>
                          )}
                          <div className="order_details_info_group">
                            <p className="order_details_info_label">Selling Price</p>
                            <p className="order_details_info_value">₹{item.price.toFixed(2)}</p>
                          </div>
                          <div className="order_details_info_group">
                            <p className="order_details_info_label">Quantity</p>
                            <p className="order_details_info_value">{item.quantity}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {item.productId && item.productId.packageWeight && (
                      <div className="order_details_item_specs">
                        <div className="order_details_info_group">
                          <p className="order_details_info_label">Package Weight</p>
                          <p className="order_details_info_value">{item.productId.packageWeight}</p>
                        </div>
                        {item.productId.packageSize && item.productId.packageSize !== "0" && (
                          <div className="order_details_info_group">
                            <p className="order_details_info_label">Package Size</p>
                            <p className="order_details_info_value">{item.productId.packageSize}</p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div className="order_details_summary">
                <div className="order_details_total">
                  <span className="order_details_total_label">Total Amount</span>
                  <span className="order_details_total_value">₹{order.totalAmount.toFixed(2)}</span>
                </div>
              </div>
            </div>

            <div className="order_details_card">
              <div
                className="order_details_card_header order_details_expandable"
                onClick={() => setIsPaymentExpanded(!isPaymentExpanded)}
              >
                <div className="order_details_header_content">
                  <h4 className="order_details_card_title">Payment Information</h4>
                  <div className="order_details_expand_icon">{isPaymentExpanded ? <ChevronUp /> : <ChevronDown />}</div>
                </div>
                <p className="order_details_subtitle">Payment details and status</p>
              </div>

              {isPaymentExpanded && (
                <div className="order_details_payment_info">
                  <div className="order_details_info_grid">
                    <div className="order_details_info_group">
                      <p className="order_details_info_label">Payment Method</p>
                      <p className="order_details_info_value order_details_highlight">{order.paymentMethod}</p>
                    </div>
                    <div className="order_details_info_group">
                      <p className="order_details_info_label">Payment Status</p>
                      <p className={`order_details_info_value order_details_status_text_${order.paymentStatus.toLowerCase()}`}>
                        {order.paymentStatus}
                      </p>
                    </div>
                    <div className="order_details_info_group">
                      <p className="order_details_info_label">Total Amount</p>
                      <p className="order_details_info_value order_details_highlight">₹{order.totalAmount.toFixed(2)}</p>
                    </div>
                    <div className="order_details_info_group">
                      <p className="order_details_info_label">Order Date</p>
                      <p className="order_details_info_value">{formatDate(order.createdAt)}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="order_details_card">
              <div
                className="order_details_card_header order_details_expandable"
                onClick={() => setIsShippingExpanded(!isShippingExpanded)}
              >
                <div className="order_details_header_content">
                  <h4 className="order_details_card_title">Shipping Information</h4>
                  <div className="order_details_expand_icon">
                    {isShippingExpanded ? <ChevronUp /> : <ChevronDown />}
                  </div>
                </div>
                <p className="order_details_subtitle">Delivery address and shipping details</p>
              </div>

              {isShippingExpanded && (
                <div className="order_details_shipping_info">
                  <div className="order_details_info_group">
                    <p className="order_details_info_label">Shipping Address</p>
                    <p className="order_details_info_value">{order.shippingAddress}</p>
                  </div>
                  <div className="order_details_info_group">
                    <p className="order_details_info_label">Contact Information</p>
                    <p className="order_details_info_value">{order.user.phone}</p>
                  </div>
                  <div className="order_details_info_group">
                    <p className="order_details_info_label">Email</p>
                    <p className="order_details_info_value">{order.user.email}</p>
                  </div>
                  <div className="order_details_info_group">
                    <p className="order_details_info_label">Shipping Method</p>
                    <p className="order_details_info_value">Standard Delivery (3-5 business days)</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="order_details_sidebar">
            <div className="order_details_card">
              <div
                className="order_details_card_header order_details_expandable"
                onClick={() => setIsTimelineExpanded(!isTimelineExpanded)}
              >
                <div className="order_details_header_content">
                  <h4 className="order_details_card_title">Order Timeline</h4>
                  <div className="order_details_expand_icon">
                    {isTimelineExpanded ? <ChevronUp /> : <ChevronDown />}
                  </div>
                </div>
                <p className="order_details_subtitle">Status history and updates</p>
              </div>

              {isTimelineExpanded && (
                <div className="order_details_timeline_list">
                  <div className="order_details_timeline_item order_details_timeline_completed">
                    <div className="order_details_timeline_icon">
                      <Check />
                    </div>
                    <div className="order_details_timeline_content">
                      <h3 className="order_details_timeline_title">Order Placed</h3>
                      <p className="order_details_timeline_description">Order was successfully placed</p>
                      <p className="order_details_timeline_date">{formatDate(order.createdAt)}</p>
                    </div>
                  </div>

                  <div className={`order_details_timeline_item ${order.orderStatus === "Processing" ? "order_details_timeline_current" : order.orderStatus === "Shipped" || order.orderStatus === "Delivered" ? "order_details_timeline_completed" : ""}`}>
                    <div className="order_details_timeline_icon">
                      <Clock />
                    </div>
                    <div className="order_details_timeline_content">
                      <h3 className="order_details_timeline_title">Processing</h3>
                      <p className="order_details_timeline_description">Order is being processed</p>
                      <p className="order_details_timeline_date">
                        {order.orderStatus === "Processing" || order.orderStatus === "Shipped" || order.orderStatus === "Delivered" 
                          ? formatDate(order.createdAt) 
                          : "Pending"}
                      </p>
                    </div>
                  </div>

                  <div className={`order_details_timeline_item ${order.orderStatus === "Shipped" ? "order_details_timeline_current" : order.orderStatus === "Delivered" ? "order_details_timeline_completed" : ""}`}>
                    <div className="order_details_timeline_icon">
                      <Package />
                    </div>
                    <div className="order_details_timeline_content">
                      <h3 className="order_details_timeline_title">Shipped</h3>
                      <p className="order_details_timeline_description">Order has been shipped</p>
                      <p className="order_details_timeline_date">
                        {order.orderStatus === "Shipped" || order.orderStatus === "Delivered" 
                          ? formatDate(order.createdAt) 
                          : "Pending"}
                      </p>
                    </div>
                  </div>

                  <div className={`order_details_timeline_item ${order.orderStatus === "Delivered" ? "order_details_timeline_current" : ""}`}>
                    <div className="order_details_timeline_icon">
                      <Truck />
                    </div>
                    <div className="order_details_timeline_content">
                      <h3 className="order_details_timeline_title">Delivered</h3>
                      <p className="order_details_timeline_description">Order has been delivered</p>
                      <p className="order_details_timeline_date">
                        {order.orderStatus === "Delivered" 
                          ? formatDate(order.createdAt) 
                          : "Pending"}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withAuth(OrderDetails);